import React, { createContext, useState, useContext } from "react";

const SelectedClientContext = createContext();

export const SelectedClientProvider = ({ children }) => {
    const [selectedClient, setSelectedClient] = useState(null);

    return (
        <SelectedClientContext.Provider value={{ selectedClient, setSelectedClient }}>
            {children}
        </SelectedClientContext.Provider>
    );
};

export const useSelectedClient = () => useContext(SelectedClientContext);
